import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";

// ----------------------------------------------------------------------

export const PartnerAdminActions = {};

// THUNKS
// Status------------------------------------------------------------------

PartnerAdminActions.isAdmin = (email, callback) => {
  return (dispatch, getState) => {

    const state = getState();

    let {
      data
    } = state.token;

    ExecuteRequest(
      GlamboxEndpoints.Partner.isAdmin,
      Object.assign(
        {},
        {
          email: email,
        }
      ),
      "GET",
      {
        Authorization: data.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;
        if (callback) callback(response);
      }
    );
  }
}


